module.exports = __webpack_public_path__ + "static/media/Outfit_300Light.ad7b6650.ttf";